import React from 'react'
import { useNavbar } from '../providers/navbar'
import increaseIcon from "../images/increaseIcon.png";
import logo from "../images/MainLogo.svg";
import plogonLogo from "../images/plygonLogo.png";
import { FaBars, FaChevronDown } from 'react-icons/fa6'
import { Link } from 'react-router-dom';

const Header = () => {
    const {openNavbar} = useNavbar()
  return (
    <header>
         <div className="py-5 px-2  md:px-5 flex justify-between">
        <div className="flex items-center text-lg font-semibold">
          <button onClick={()=>openNavbar()} className="mr-3">
            <FaBars />
          </button>
            <img src={logo} className="w-[100px] flex md:hidden" alt="Swiss Gold"/>
          <div className="hidden md:flex">
            <h3 className="text-yellow-300 md:text-lg">Gold(oz)=$2,67</h3>
            <div className="flex items-center text-sm">
              <img
                className="h-[8px] w-[16px] "
                src={increaseIcon}
                alt={"increase"}
              />
              <h3 className="font-semibold text-green-500">%0.54</h3>
            </div>
          </div>
        </div>
        <div className="flex items-center  justify-center">
          <button className="w-[90px] md:w-auto border-[1px] border-black md:border-white text-sm font-semibold bg-transparent md:bg-gray-500/25 rounded-3xl mx-2 flex items-center px-4 py-2 ">
            <img
              className="mx-1"
              src={plogonLogo}
              alt=" "
              width={"27px"}
              height={"27px"}
            />
            <p className="hidden md:flex">Ploygon Network</p>
            <FaChevronDown className="mx-1 w-[10px]" />
          </button>
          <Link className=" flex m-2 px-4 md:px-6 py-2 md:py-3 font-bold text-gray-900 bg-yellow-400 rounded-3xl transition-all duration-300 hover:bg-yellow-300 hover:scale-110 shadow-lg hover:shadow-yellow-500/30 transform origin-center">
            Connect<span className="hidden md:flex ml-1">Wallet</span>
          </Link>
        </div>
      </div>
    </header>
  )
}

export default Header
